import { MetaAuditLogStatus } from '../types';

export const STATUS_CONFIG: Record<
  MetaAuditLogStatus,
  { label: string; color: 'green' | 'yellow' | 'red' }
> = {
  completed: {
    label: 'Completed',
    color: 'green',
  },
  completed_no_matches: {
    label: 'Completed (No matches)',
    color: 'yellow',
  },
  failed: {
    label: 'Failed',
    color: 'red',
  },
};
